import { createGlobalStyle } from 'styled-components';
import colors from './colors';

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600;700&display=swap');

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  html, body, #root {
    margin: 0 !important;
    padding: 0 !important;
    width: 100%;
    min-height: 100%;
    border: none !important;
    outline: none !important;
  }

  body {
    font-family: 'Quicksand', -apple-system, BlinkMacSystemFont, sans-serif;
    background: ${colors.background.dark};
    color: ${colors.text.body};
    line-height: 1.6;
    overflow-x: hidden;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Quicksand', sans-serif;
    font-weight: 700;
    line-height: 1.2;
  }

  a {
    text-decoration: none !important;
    color: inherit;
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
    font-family: inherit;
    transition: all 0.3s ease;
  }

  img {
    max-width: 100%;
    display: block;
  }

  ::selection {
    background: ${colors.primary.main};
    color: ${colors.text.white};
  }

  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-track {
    background: ${colors.background.cream};
  }

  ::-webkit-scrollbar-thumb {
    background: ${colors.primary.light};
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${colors.primary.main};
  }
`;

export default GlobalStyles;
